import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentQExecution } from 'src/app/model/equipment';
import { GenericClass } from 'src/app/model/genericClass';
import { EquipmentTypeQualificatesService } from 'src/app/services/equipmentTypeQualificates.service';
import { EquipmentTypeQualificationEnum } from '../../../../model/equipmentType';
import { SnackBarService } from '../../../../services/snackBar.service';
import { ExecutionEditQDeviationComponent } from '../execution-edit-q-deviation/execution-edit-q-deviation.component';
import { ExecutionQ } from '../../../../model/execution';
import * as _ from 'lodash';

export interface DialogDataEquipment {
  equipment: EquipmentQExecution;
  isEdit: boolean;
  isOnlyPQ: boolean;
  ex: ExecutionQ,
}

@Component({
    selector: 'app-execution-edit-q-equipment-dialog',
    templateUrl: './execution-edit-q-equipment-dialog.component.html',
    standalone: false,
})
export class ExecutionEditEquipmentDialogComponent implements OnInit {

  tituloDialog: string;
  form: FormGroup;
  mappingTypes = [{value: 'summer'}, {value: 'winter'}];

  equipmentTypes: GenericClass[];
  allowedSummerWinter = [EquipmentTypeQualificationEnum.WAREHOUSE, EquipmentTypeQualificationEnum.VEHICLE]

  constructor(
    fb: FormBuilder,
    private translate: TranslateService,
    private equipmentTypeQualificatesService: EquipmentTypeQualificatesService,
    private dialogRef: MatDialogRef<ExecutionEditEquipmentDialogComponent>,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataEquipment
  ) {
    if (data.isEdit) {
      // eslint-disable-next-line max-len
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.edit', { name: !data.equipment.serialNumber ? data.equipment.equipment : data.equipment.serialNumber   }) as string;
    } else {
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.create') as string;
    }

    this.form = fb.group({
      equipment: [this.data.equipment, [Validators.required]],
      maker: [this.data.equipment.maker],
      model: [this.data.equipment.model],
      serialNum: [this.data.equipment.serialNumber],
      idType: [this.data.equipment.idType, [Validators.required]],
      rotorSerial: [this.data.equipment.rotorSerial],
      rotorModel: [this.data.equipment.rotorModel],
      location: [this.data.equipment.location, [Validators.required]],
      internalId: [this.data.equipment.internalId]
    });
    this.equipmentTypeQualificatesService.findAll().subscribe((res: GenericClass[]) => {
      this.equipmentTypes = res;
    });
  }

  ngOnInit(): void {
  }

  onOkClick(): void {
    let errs = [];
    if (this.form.valid) {
      if (!this.requiredReason()) {
        this.data.equipment.reasonChange = null;
      } else if (this.data.equipment.reasonChange == null || this.data.equipment.reasonChange === '') {
        errs.push(this.translate.instant('common.reasonChangeError'));
      }
      
      if (errs.length === 0) {
        this.dialogRef.close(this.data.equipment);
      } else {
        const error = errs.join('\n');
        this.snackBarService.sendError(error);
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showEquipmentAllowed(): boolean {
    return this.allowedSummerWinter.includes(this.data.equipment.idType) && this.data.isOnlyPQ;
  }

  showIsCentrifuge(): boolean {
    return EquipmentTypeQualificationEnum.CENTRIFUGE === this.data.equipment?.idType;
  }

  requiredReason(): boolean {
    let res = false;

    if (this.data.equipment.fromProtocol) {
      res = res || this.data.equipment.equipment !== this.data.equipment.equipmentProtocol;
      res = res || this.data.equipment.internalId !== this.data.equipment.internalIdProtocol;
      res = res || this.data.equipment.location !== this.data.equipment.locationProtocol;
      res = res || this.data.equipment.maker !== this.data.equipment.makerProtocol;
      res = res || this.data.equipment.model !== this.data.equipment.modelProtocol;
      res = res || this.data.equipment.serialNumber !== this.data.equipment.serialNumProtocol;
      res = res || this.data.equipment.idType !== this.data.equipment.idTypeProtocol;
    }

    return res;
  }

  onChangeDeviation() {
    const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
      minWidth: '70%',
      maxHeight: '95vh',
      data: {
        //deviation: _.cloneDeep(resSelected.executionQTestDeviations),
        idStatus: this.data.ex.idStatus,
        idExecution: this.data.ex.id,
        //idExecutionTest: this.data.data.id,
        isEditList: false
      }
    });
  }
}
